import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch, useParams, useHistory, useLocation } from "react-router-dom";

import cx from 'classnames';
import _ from 'lodash';
import dateformat from "dateformat";
import moment from 'moment'
import { Button } from 'react-bootstrap';

import { fetchingFirstCapturedLeads, fetchingLatestCampaignLeads, fetchingLeadsJourney, fetchingStoryboardLeadDetails, invalidateStoryboardLeadDetails } from 'actions/leads';
import { PageInteractions } from '../components/pageInteractions';
import InfiniteScroll from 'components/InfiniteScroll';
import LinesEllipsis from 'react-lines-ellipsis'
import { renderInitials } from '../components';
import { AssetInteractions } from '../components/assetInteractions';
import { getBaseUrl } from 'services/util';
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';
import Tooltip from 'components/Tooltip';

import styles from './leadProfile.module.scss';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_LEAD_DETAIL_VIEWED } from 'constants/mixpanelEvents';
import { createMixpanelEvent } from 'actions/mixpanel';
import { formatDurationWithLabel } from '../../reports/reporthelpers';


const LeadProfile = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  let { storyboardId } = useParams();

  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const handleBackClick = () => {
    history.goBack()
  }

  const { profileId, reportDate, data } = location.state;
  const customFieldsData = data.fields || {};

  const leadProfile = useSelector(state => _.get(state, 'lead.summary.visitor', {}));
  const loading = useSelector(state => _.get(state, 'lead.summary.loading'));
  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));

  useEffect(() => {

    const request = {
      storyboard: storyboardId,
      metricType: "leads",
      startDate: _.get(reportDate, 'startDate'),
      endDate: _.get(reportDate, 'endDate')
    }

    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_LEAD_DETAIL_VIEWED, storyboard.id, storyboard.name, storyboard.type)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))

    dispatch(fetchingStoryboardLeadDetails(profileId, request))

    return () => {
      dispatch(invalidateStoryboardLeadDetails());
    };
  }, [])

  const _renderLastActivity = () => {
    if (loading) {
      return;
    }

    const lastEventDate = dateformat(leadProfile.lastEventDate, 'ddmmyyyy,h:MM:ss TT')
    return moment(lastEventDate, 'DDMMYYYY,h:mm:ss a').fromNow();
  }

  return (
    <div className={styles.leadProfile}>
      <section className={styles.detailsContainer}>
        <div className={styles.navigationPanel}>
          <Button variant="light" onClick={handleBackClick} className={styles.backButton}>
            <i className={cx(styles.backIcon, 'cleverstory-back')} />
            Back
          </Button>

          {/* <Button variant='info' className={styles.menuButton}>
            <i className={cx(styles.backIcon, 'cleverstory-more')} />
          </Button> */}
        </div>
        <div className={styles.profileOverview}>
          <div className={styles.basicInfo}>
            <div className={styles.imageContainer}>
              <div className={styles.visitorInitials}>{renderInitials(leadProfile)}</div>
            </div>
            <div className={styles.details}>
              <h4 className={styles.name}>{leadProfile.firstName ? leadProfile.firstName : '' + ' ' + leadProfile.lastName ? leadProfile.lastName : ''}</h4>
              <p className={styles.email}>
                <TruncatedTextWithTooltip content={_.get(leadProfile, 'email', "-")} maxWidth={310} placement='top' />
              </p>
              <p className={styles.last_activity}>{_.get(leadProfile, 'workPhone') || "-" }</p>
            </div>
          </div>
          <div className={styles.recordsWrapper}>
            <LeadRecords heading="Views" subheading="Recorded" data={Math.round(_.get(leadProfile, 'views', 0))} path={'/images/reports/sessions.svg'} />
            <LeadRecords heading="Total Time" subheading="Spent" data={formatDurationWithLabel(_.get(leadProfile, 'timeSpent', 0)).value} path={'/images/leads/timeSpent.svg'} />
            <LeadRecords heading="Completion" subheading="Percentage" data={`${_.get(leadProfile, 'completion', 0)}%`} path={'/images/leads/completion.svg'} type="pageView" />
          </div>
        </div>
        
        <div className={styles.captured}>
          <h5 className={styles.capturedHeading}>Captured On</h5>
          <div className={styles.capturedDetails}>
            <div className={styles.capturedFields}>
              <p className={styles.lable}>Date</p>
              <p className={styles.value}>{dateformat((data.contact.createdDate), 'dd mmm yyyy')}</p>
            </div>

            <div className={styles.capturedFields}>
              <p className={styles.lable}>Campaign/Page</p>
              <p className={styles.value}>
              <TruncatedTextWithTooltip content={data.campaignName || "-"} maxWidth={180} placement='top' />/ 
              <TruncatedTextWithTooltip content={storyboard.name || "-"} maxWidth={180} placement='top' />
              </p>
            </div>

            <div className={styles.capturedFields}>
              <p className={styles.lable}>Source/Medium</p>
              <p className={styles.value}>
              <TruncatedTextWithTooltip content={data.campaignSource || "-"} maxWidth={180} placement='top' />/
              <TruncatedTextWithTooltip content={data.campaignMedium || "-"} maxWidth={180} placement='top' />
              </p>
            </div>
          </div>
          <p className={styles.lastActivity}>Last Activity: {_renderLastActivity()}</p>
        </div>
        <hr className={styles.separator_line} />
        <div className={styles.profileDetails}>
          <LeadDetails profileId={profileId} reportDate={reportDate} />
          <LeadJourney profileId={profileId} reportDate={reportDate} />
        </div>
        <hr className={styles.separator_line_bottom} />
        {customFieldsData && customFieldsData.length > 0 &&
          <CustomFieldsDetails data={customFieldsData}  />
        }
      </section>
      <div className={styles.interactions}>
        <PageInteractions profileId={profileId} reportDate={reportDate} />
        <AssetInteractions profileId={profileId} reportDate={reportDate} />
      </div>
    </div>
  )
}

const CustomFieldsDetails = ({data}) => {
  function renderValue(value) {
    switch (typeof value) {
      case 'boolean':
        return value ? 'True' : 'False';

      default:
        return value || "-";
    }
  }
  
  return (
    <>
      <section className={styles.customFieldsDetails}>
        <div>
          <header className={styles.sectionHeader}>
            <h4 className={styles.sectionHeading}>Custom Fields</h4>
          </header>
  
          <div className={styles.detailContainer}>
            {data
              .filter((field) => field.uid === null)
              .map((field, index) => {
              const isArray = Array.isArray(field.values);
              const fieldValue = isArray ? field.values.join(', ') : renderValue(field.values);

              return (
                <div className={styles.detail} key={index}>
                  <h6 className={styles.detailHeading}>
                    <TruncatedTextWithTooltip content={field.name} maxWidth="200" placement="top" />
                  </h6>
                  <span className={styles.detailValue}>
                    <TruncatedTextWithTooltip content={fieldValue || "-"} maxWidth="200" placement="top" />
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

const LeadRecords = ({ heading, subheading, data, path, iconClassname, type="" }) => {
  const PageInteractions = useSelector(state => _.get(state, 'lead.pagesInteractions.items')) || [];

  return (
    <div className={styles.statistics}>
      <div className={styles.icon}>
        <img src={path} className={iconClassname} alt="" />
      </div>

      <div className={styles.content}>
        <h6 className={styles.heading}>{heading}</h6>
        <span className={styles.sub_heading}>{subheading}</span>
        <span className={styles.stat}>{data}</span>
      </div>
    </div>
  )
}

const LeadDetails = ({ profileId, reportDate }) => {
  const dispatch = useDispatch();
  let { storyboardId } = useParams();

  const { startDate, endDate } = reportDate;

  const leadProfile = useSelector(state => _.get(state, 'lead.summary.visitor', {}));
  const detailsloader = useSelector(state => _.get(state, 'lead.summary.loading'));
  const firstCapturedLead = useSelector(state => _.get(state, 'lead.firstCaptured.items', {}));
  const latestCampaignLead = useSelector(state => _.get(state, 'lead.latestCampaign.items', {}));


  useEffect(() => {
    const dataRequest = {
      storyboard: storyboardId,
      metricType: "leads",
      startDate: startDate,
      endDate: endDate
    }

    dispatch(fetchingFirstCapturedLeads(profileId, dataRequest))
    dispatch(fetchingLatestCampaignLeads(profileId, dataRequest))
  }, [])

  return (
    <div className={styles.leadDetailsSection}>
      <section className={styles.sectionContainer}>
        <header className={styles.sectionHeader}>
          <h4 className={styles.sectionHeading}>Basic Fields</h4>
        </header>

        <div className={styles.detailContainer}>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>First Name</h6>
            <span className={styles.detailValue}>{leadProfile.firstName ? leadProfile.firstName : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Email</h6>
            <span className={styles.detailValue}>
              <TruncatedTextWithTooltip content={leadProfile.email} maxWidth={260} placement='top' />
            </span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Last Name</h6>
            <span className={styles.detailValue}>{leadProfile.lastName ? leadProfile.lastName : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Company</h6>
            <span className={styles.detailValue}>{leadProfile.company ? leadProfile.company : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Designation</h6>
            <span className={styles.detailValue}>{leadProfile.title ? leadProfile.title : '-'}</span>
          </div>
          <div className={styles.detail}>
            <h6 className={styles.detailHeading}>Work Phone</h6>
            <span className={styles.detailValue}>{leadProfile.workPhone ? leadProfile.workPhone : '-'}</span>
          </div>
        </div>
      </section>
    </div>
  )
}

const RenderName = ({ data, className }) => {
  const [tooltip, setTooltip] = useState(false);

  const handleTooltip = (truncated) => {
    const { clamped } = truncated;
    setTooltip(clamped);
  }

  if (!data) {
    return (
      <span className={styles.detailValue}>{'-'}</span>
    )
  }

  return (
    <Tooltip placement="top" disabled={!tooltip} content={data}>
      <span className={className}>
        <LinesEllipsis basedOn="letters" onReflow={handleTooltip} text={data} maxLine='1' ellipsis='...' />
      </span>
    </Tooltip>
  )
}

const LeadJourney = ({ profileId, reportDate }) => {
  const dispatch = useDispatch();
  let { storyboardId } = useParams();

  useEffect(() => {
    if (reportDate) {
      handleLeadsJourney(0)
    }
  }, [reportDate])

  const journeyData = useSelector(state => _.get(state, 'lead.journey.items', [])) || [];
  const loading = useSelector(state => _.get(state, 'lead.journey.loading'));
  const pagination = useSelector(state => _.get(state, 'lead.journey.pagination', {}));
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  const handlePageChange = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    handleLeadsJourney(nextPage);
  }

  const handleLeadsJourney = (page) => {
    if (!storyboardId) {
      return
    }

    const request = {
      storyboard: storyboardId,
      startDate: _.get(reportDate, 'startDate'),
      endDate: _.get(reportDate, 'endDate')
    }

    dispatch(fetchingLeadsJourney(profileId, request, page, 20))
  }

  return (
    <section className={styles.leadJourney}>
      <h6 className={styles.sectionHeading}>Lead Journey</h6>
      <div className={styles.journeyContainer}>
        <InfiniteScroll
          className={cx(styles.scrollable)}
          loading={loading}
          hasMore={hasMoreItems}
          loadMore={() => { handlePageChange() }}
        >
          {journeyData.map((interaction, index) => {
            return (
              <div key={index} className={styles.journeyDetails}>
                <div className={styles.journeyTimeline}>
                  <span>{dateformat(interaction.eventDate, 'dd mmm yyyy')}</span>
                </div>
                <div className={styles.journeyInteraction}>
                  <span className={styles.type}>{_.get(interaction, 'type', '')}</span>
                  <span className={styles.name}>{_.get(interaction, 'name', '')}</span>
                  {_.get(interaction, 'campaign') !== null && <span className={styles.campaign}>{`${_.get(interaction, 'campaign.source', '')}/${_.get(interaction, 'campaign.medium', '')}`}</span>}
                </div>
              </div>
            )
          })
          }
        </InfiniteScroll>
      </div>
    </section>
  )
}

export default LeadProfile